import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { Router } from "@angular/router";

import { ServiceType } from "../../../apis/networkdashboard/graphql/graphql";
import { HealthStatus } from "../../../apis/stats/rest/models/health-status";
import { phraseDetailPath } from "../../../pages/subscription-detail/subscription-detail-redirection";
import { LightPathSubscriptionDetails } from "../../../pages/subscription-detail/types";
import { AuthService } from "../../../services/authservice";
import { PortVisualiser } from "../port-visualiser/port-visualiser";
import { ServiceId } from "../service-id/service-id";
import { ServiceTitleBlock } from "../service-title-block/service-title-block";

export type PortTileSap = LightPathSubscriptionDetails["circuits"][number]["endpoints"][number];

@Component({
  selector: "sap-tile",
  templateUrl: "sap-tile.html",
  styleUrl: "../port-visualiser/port-visualiser.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, ServiceId, ServiceTitleBlock, PortVisualiser],
})
export class SapTile {
  private auth = inject(AuthService);
  private router = inject(Router);

  protected sap = input.required<PortTileSap>();
  protected healthStatus = input.required<HealthStatus>();

  protected showVisual = computed(() => this.port()?.customer?.customerId === this.auth.viewingCustomer().customerId);

  protected port = computed(() => this.sap().port);
  protected customerDescription = computed(() => this.port()?.customerDescription ?? "");
  protected portId = computed(() => this.port()?.subscriptionId);
  protected tags = computed(() => this.port()?.tags ?? []);

  protected portOwner = computed(() => this.sap().organisation);
  protected serviceTag = computed(() => (this.sap() as any).serviceTag);
  protected vlanrange = computed(() => this.sap().vlanrange);
  protected showVlanrange = computed(() => this.vlanrange() !== "0" && this.vlanrange() !== "");

  private address = computed(() => this.port()?.address);
  protected city = computed(() => this.address()?.city);
  protected street = computed(() => this.address()?.street);
  protected number = computed(() => this.address()?.number);

  protected navigateToService(service: ServiceType): void {
    this.router.navigate(phraseDetailPath(service.product.type, service.product.tag, service.subscriptionId));
  }
}
